// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3pfow","header":"ClearentDisclaimer_header__2m9j8","inner":"ClearentDisclaimer_inner__2skCF"};